export const MEDIAS = [
  { link: "https://github.com/ming-tsai", icon: "mdi-github" },
  { link: "https://linkedin.com/in/ming-tsai", icon: "mdi-linkedin" },
];
